'use client';
import React, { useState } from 'react';
import { PlayCircle, CheckCircle2, Download, ChevronDown } from 'lucide-react';
import StatusBadge from '@/components/ui/StatusBadge';
import { useRole } from '@/context/RoleContext';

export default function PayrollRunHeader() {
  const [runStatus, setRunStatus] = useState<'draft' | 'approved'>('draft');
  const [calculating, setCalculating] = useState(false);
  const { permissions } = useRole();

  const handleCalculate = () => {
    setCalculating(true);
    setTimeout(() => {
      setCalculating(false);
      setRunStatus('approved');
    }, 1800);
  };

  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <div className="flex items-center gap-3 mb-1">
          <h1 className="text-2xl font-600 text-foreground tracking-tight">Payroll Run — Week 18</h1>
          <StatusBadge variant={runStatus} />
        </div>
        <p className="text-sm text-muted-foreground">
          Pay period: <span className="font-500 text-foreground">28 Apr – 04 May 2026</span>
          <span className="mx-2 text-border">·</span>
          Pay date: <span className="font-500 text-foreground">09 May 2026</span>
          <span className="mx-2 text-border">·</span>
          <span className="font-500 text-foreground">47 workers</span>
          <span className="mx-2 text-border">·</span>
          Run ID: <span className="font-mono text-[12px]">PR-2026-W18</span>
        </p>
      </div>
      <div className="flex items-center gap-2">
        {permissions?.canDownloadPayslips && (
          <button className="flex items-center gap-2 px-3 py-2 text-[13px] font-500 text-muted-foreground bg-card border border-border rounded-lg hover:bg-secondary transition-all duration-150 active:scale-95">
            <Download size={14} />
            Download All Payslips
          </button>
        )}
        {permissions?.canExportPayroll && (
          <div className="relative group">
            <button className="flex items-center gap-2 px-3 py-2 text-[13px] font-500 text-muted-foreground bg-card border border-border rounded-lg hover:bg-secondary transition-all duration-150 active:scale-95">
              Export <ChevronDown size={13} />
            </button>
          </div>
        )}
        {permissions?.canRunPayroll && (
          <button
            onClick={handleCalculate}
            disabled={calculating || runStatus === 'approved'}
            className={`flex items-center gap-2 px-4 py-2 text-[13px] font-600 rounded-lg transition-all duration-150 active:scale-95 shadow-sm min-w-[160px] justify-center ${
              runStatus === 'approved' ?'bg-success/10 text-success border border-success/20 cursor-default' :'text-primary-foreground bg-primary hover:bg-primary/90'
            } disabled:opacity-60 disabled:cursor-not-allowed`}
          >
            {calculating ? (
              <>
                <span className="w-3.5 h-3.5 border-2 border-primary-foreground/30 border-t-primary-foreground rounded-full animate-spin shrink-0" />
                Calculating...
              </>
            ) : runStatus === 'approved' ? (
              <>
                <CheckCircle2 size={14} />
                Payroll Calculated
              </>
            ) : (
              <>
                <PlayCircle size={14} />
                Calculate Payroll
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
}